import { api } from '../../../services/api.js';

async function initFreeExerciseSession(token, moduleId, medialinkId, studioGroup) {
    const { data } = await api.get(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function initAssignmentSession(token, moduleId, assignmentId, studioGroup) {
    const { data } = await api.get(`api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function initFreeExerciseSessionScorableMaterial(token, moduleId, materialId, studioGroup) {
    const { data } = await api.get(`api/studio/user/modules/${moduleId}/user-material/${materialId}/exercise-session`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function startFreeExerciseSession(token, moduleId, medialinkId, language, studioGroup) {
    const { data: { exerciseUrl }, } = await api.put(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session/start`, {
        language,
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return exerciseUrl;
}
async function pauseFreeExerciseSession(token, moduleId, medialinkId, studioGroup) {
    const { data } = await api.put(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session/pause`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function resumeFreeExerciseSession(token, moduleId, medialinkId, studioGroup) {
    const { data: { exerciseUrl }, } = await api.put(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session/resume`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return exerciseUrl;
}
async function stopFreeExerciseSession(token, moduleId, medialinkId, studioGroup) {
    const { data } = await api.delete(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function reviewExerciseSession(token, moduleId, medialinkId, sessionId, studioGroup) {
    const { data } = await api.get(`api/studio/modules/${moduleId}/medialinks/${medialinkId}/exercise-session/${sessionId}/review`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function startAssignmentSession(token, moduleId, assignmentId, language, studioGroup) {
    const { data: { exerciseUrl }, } = await api.put(`api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session/start`, {
        language,
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return exerciseUrl;
}
async function pauseAssignmentSession(token, moduleId, assignmentId, studioGroup) {
    const { data } = await api.put(`api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session/pause`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}
async function resumeAssignmentSession(token, moduleId, assignmentId, studioGroup) {
    const { data: { exerciseUrl }, } = await api.put(`api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session/resume`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return exerciseUrl;
}
async function stopAssignmentSession(token, moduleId, assignmentId, studioGroup) {
    const { data } = await api.delete(`api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session`, {
        headers: {
            Authorization: `Bearer ${token}`,
            studioGroup,
        },
    });
    return data;
}

export { initAssignmentSession, initFreeExerciseSession, initFreeExerciseSessionScorableMaterial, pauseAssignmentSession, pauseFreeExerciseSession, resumeAssignmentSession, resumeFreeExerciseSession, reviewExerciseSession, startAssignmentSession, startFreeExerciseSession, stopAssignmentSession, stopFreeExerciseSession };
